import React, {useEffect, useState} from 'react';
import {Button, Card, Col, ConfigProvider, Form, Input, InputNumber, Modal, Row, Select, Space, Typography} from 'antd';
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import HomeColors from "../../styles/HomeColors";
import {CloseOutlined} from "@mui/icons-material";
import AvaluacioColors from "../../styles/AvaluacioColors";
import {PostProjecteConfiguracio} from "../../dao/abp/PostProjecteConfiguracio";
import {PostAulaConfiguracio} from "../../dao/abp/PostAulaConfiguracio";
import CopyModal from "./CopyModal";
import {useParams} from "react-router-dom";

interface Props {
    element: any;
    visible: boolean;
    id_aula: string;
    json: any;
    onClose: (value: boolean) => void;
}

const RaModal: React.FC<Props> = (props: Props) => {
    const [form] = Form.useForm();
    const [copyModal, setCopyModal] = useState<boolean>(false);


    useEffect(() => {
        if (props.visible && props.element) {
            form.setFieldsValue(props.element);
        }
    }, [props.visible, props.element]);

    const handleCancel = () => {
        props.onClose(false);
    };


    async function submitData() {

        const formData = form.getFieldsValue();


        await PostAulaConfiguracio(props.element.id + "", formData);

        console.log("Form Data:", formData);
        console.log(JSON.stringify(formData));

        props.onClose(true);
    }

    function clonar() {
        setCopyModal(true);
    }

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Editar RAs"
                open={props.visible}
                onCancel={handleCancel}
                footer={[]}
                width={1000}
            >
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    form={form}
                    name="dynamic_form_complex"
                    style={{ maxWidth: 1500 }}
                    autoComplete="off"
                    onFinish={submitData}
                    initialValues={{ items: props.json.items || [] }} // Se asegura de que 'items' esté presente
                >
                    <Form.List name="items">
                        {(fields, { add, remove }) => (
                            <div style={{ display: 'flex', rowGap: 16, flexDirection: 'column' }}>
                                {fields.map((field) => (
                                    <Card
                                        size="small"
                                        title={`Mòdul ${field.name}`}
                                        key={field.key}
                                        /*extra={
                                            <CloseOutlined
                                                onClick={() => {
                                                    remove(field.name);
                                                }}
                                            />
                                        }*/
                                    >
                                        <Form.Item label="CODI Mòdul" name={[field.name, 'name']} initialValue={props.element.nom}>
                                            <Input/>
                                        </Form.Item>

                                        {/* Nested Form.List */}
                                        <Form.Item label="RAs">
                                            <Form.List name={[field.name, 'list']}>
                                                {(subFields, subOpt) => (
                                                    <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                                        {subFields.map((subField, index) => (

                                                            <Space key={subField.key}>
                                                                <Form.Item noStyle name={[subField.name, 'num']} initialValue={index+1} >
                                                                    <InputNumber
                                                                        min={1}
                                                                        max={9}
                                                                        placeholder="número"
                                                                        addonBefore={"RA"}
                                                                        disabled={true} // Deshabilitar si no es nuevo
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item noStyle name={[subField.name, 'desc']}
                                                                           rules={[{ required: true, message: 'Camp obligatori!', whitespace: true }]}>
                                                                    <Input placeholder="descripció" />
                                                                </Form.Item>
                                                                <Form.Item noStyle name={[subField.name, 'pes']}
                                                                           rules={[{ required: true, message: 'Camp obligatori!' }]}>
                                                                    <InputNumber min={0} max={100} placeholder="pes" addonAfter={"%"} />
                                                                </Form.Item>
                                                                {/* Solo mostrar el icono de eliminar si es el último campo */}
                                                                {index === subFields.length - 1 && (
                                                                    <CloseOutlined onClick={() => subOpt.remove(subField.name)} />
                                                                )}
                                                            </Space>
                                                        ))}
                                                        <Button style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                                                                type="dashed" onClick={() => subOpt.add()} block>
                                                            + Afegir RA
                                                        </Button>
                                                    </div>
                                                )}
                                            </Form.List>
                                        </Form.Item>
                                    </Card>
                                ))}

                                <Button style={{ backgroundColor: AvaluacioColors.colors.color6 }} type="dashed" onClick={() => add()} block>
                                    + Afegir Mòdul
                                </Button>
                                <Button style={{ backgroundColor: AvaluacioColors.colors.color4 }} htmlType="submit" block>
                                    {"Actualitzar"}
                                </Button>
                                <Button style={{ backgroundColor: AvaluacioColors.colors.color4 }}
                                        onClick={() => clonar()} block>
                                    {"Clonar"}
                                </Button>
                            </div>
                        )}
                    </Form.List>
                </Form>
            </Modal>

            {copyModal && <CopyModal id_aula={props.id_aula} visible={copyModal} onClose={() => setCopyModal(false)}/>}
        </ConfigProvider>
    );
};

export default RaModal;
